import React from 'react';
import {YMaps, Map, FullscreenControl, Placemark} from 'react-yandex-maps';

const MyReactMapComponent = () => {
    return (
        <>
            <YMaps
                enterprise
                query={{
                    lang: 'ru_RU',
                    apikey: '4de870c8-5e28-4cee-a429-639e86c915d7'
                }}
            >
                <Map
                    style={{width: '100%', height: '100%'}}
                    defaultState={{
                        center: [43.896727, 42.724162],
                        zoom: 13
                    }}
                >
                    {/* Маркер на карте */}
                    <Placemark
                        modules={["geoObject.addon.balloon"]}
                        defaultGeometry={[43.896727, 42.724162]}
                        properties={{
                            balloonContentBody:
                                `
                                <div>
                                    <h5>Санаторий "Центросоюз"</h5>
                                    <h6>улица Володарского, 12</h6>
                                </div>
                            `
                        }}
                    />
                    <FullscreenControl />
                </Map>
            </YMaps>
        </>
    );
};

export default MyReactMapComponent;